const educationArray = [
  {
    id: 1,
    date: '2021 - 2025',
    title: "Bachelor's of Technology (B.Tech) In Computer Science",
    text: 'Shri G. S. Institute of Technology and Science -- Indore, MP',
    cgpa: 'CGPA: 8.14(Till Sem-7)'
  },
  {
    id: 2,
    date: '2020 - 2021',
    title: 'Higher Secondary School (PCM)',
    text: 'Maharishi Vidya Mandir School -- Shahdol, MP',
    cgpa: 'Percentage: 94.80'
  },
  {
    id: 3,
    date: '2018 - 2019',
    title: 'High School',
    text: 'S.E.C.R High School -- Shahdol, MP',
    cgpa: 'Percentage: 86.40'
  }
]

export default educationArray
